export default __webpack_public_path__ + "static/media/header-img.1a13a7e5.png";